/**
 * 绑定状态共享管理
 */

import { computed, readonly, ref } from 'vue'
import { getCSDClient } from '@/lib/csd-adapter'
import { isPhoneBound, isWechatBound, type BindUserInfo } from './bind-account.utils'

const userInfo = ref<BindUserInfo | null>(null)
const loading = ref(false)
const loaded = ref(false)

/**
 * 刷新绑定状态
 */
export async function refreshBindUserInfo(): Promise<BindUserInfo | null> {
  const client = getCSDClient()
  if (!client) {
    return userInfo.value
  }

  loading.value = true
  try {
    const result = await client.getUserService().getUserInfo()
    userInfo.value = {
      bind_phone: result.bind_phone ?? null,
      openid: result.openid ?? null,
      unionid: result.unionid ?? null
    }
    loaded.value = true
    return userInfo.value
  } finally {
    loading.value = false
  }
}

/**
 * 首次加载绑定状态
 */
export async function ensureBindUserInfoLoaded(): Promise<BindUserInfo | null> {
  if (loaded.value) {
    return userInfo.value
  }

  return await refreshBindUserInfo()
}

/**
 * 清空绑定状态
 */
export function clearBindUserInfo() {
  userInfo.value = null
  loading.value = false
  loaded.value = false
}

export function useBindAccountState() {
  return {
    userInfo: readonly(userInfo),
    loading: readonly(loading),
    isPhoneBound: computed(() => isPhoneBound(userInfo.value)),
    isWechatBound: computed(() => isWechatBound(userInfo.value)),
    refreshBindUserInfo,
    ensureBindUserInfoLoaded,
    clearBindUserInfo
  }
}
